export default "__VITE_ASSET__erJo6RfY__"